/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'at.markpub.lens'

type $nsid = typeof $nsid

export { $nsid }

type Main = {
  $type?: 'at.markpub.lens'

  /**
   * A human-readable description of what the output of this lens is intended to be. This is optional but can be helpful for documentation purposes and for anyone trying to understand how to use the lens.
   */
  outputDescription?: string

  /**
   * A list of facet types that this lens can translate bidirectionally between. For example, if you include `pub.leaflet.richtext.facet#bold` and `at.markpub.facet#strong` then this lens can be used to translate between those two facet types and any renderer that understands either of those facet types can use this lens to render the facets it understands.
   */
  facets: l.Unknown$TypedObject[]

  /**
   * You may include code here intended to process a string with the provided facets. This is optional and not expected to be used by most lenses, but it can be helpful for testing or for providing examples of how a renderer might use the lens.
   */
  outputCode?: string

  /**
   * An optional HTML snippet that shows what the output of this lens is intended to look like. This is optional but can be helpful for documentation purposes and for anyone trying to understand how to use the lens.
   */
  outputTargetHTML?: string
}

export type { Main }

const main = /*#__PURE__*/ l.typedObject<Main>(
  $nsid,
  'main',
  /*#__PURE__*/ l.object({
    outputDescription: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    facets: /*#__PURE__*/ l.array(/*#__PURE__*/ l.typedUnion([], false)),
    outputCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    outputTargetHTML: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
